angular.module("AccountingBoxApp").component("deleteConfirmationModal", {
  templateUrl: "app/components/modal/deleteConfirmationModal.html",
  bindings: {
    onConfirm: "&",
    modalId: "@",
    body: "@"
  }
});
